import { gql } from "@apollo/client";

export const SET_EMAIL_PREFERENCE = gql`
  mutation SetEmailPreference($input: [EmailPreferenceInput!]!) {
    setEmailPreference(input: $input)
  }
`;
